// menuConfigContainer.js
var MenuConfigContainer = pc.createScript('menuConfigContainer');

MenuConfigContainer.attributes.add('menuConf', {type: 'entity', title:'config', array: true});

// initialize code called once per entity
MenuConfigContainer.prototype.initialize = function() {
    tConf = this.menuConf;
};

// swap method called for script hot-reloading
// inherit your script state here
// MenuConfigContainer.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

